import React, { useEffect, useState } from 'react';
import { AccountClient } from '@nile/graphql';
import { GET_REPORT } from '@nile/reports/src/modules/reports/graphql';
import Loading from '@nile/components/src/Svg/AnimatedSvg/Loading.svg';
import { INVOICE_STATEMENTS } from '@nile/reports/src/modules/home/constants';
import InvoiceStatementsSheet from '@nile/reports/src/modules/InvoiceStatements/InvoiceStatementsSheet';

interface InvoiceStatementsReportProps {
  data: {
    reportId: string;
    internalName: string;
    reportType: string;
  };
  setActiveReport: (report: { reportId: string; internalName: string }) => void;
  setActiveReportLoading: (loading: boolean) => void;
}

function InvoiceStatementsReport(props: InvoiceStatementsReportProps) {
  const { data, setActiveReport, setActiveReportLoading } = props;

  const [loading, setLoading] = useState(false);
  const isInvoiceStatementsReport = INVOICE_STATEMENTS === data?.reportType;

  const hasFeatureAccess = true;

  const getReport = () => {
    setLoading(true);
    AccountClient.query({
      query: GET_REPORT,
      variables: {
        reportId: data?.reportId
      },
      fetchPolicy: 'no-cache'
    })
      .then((res: any) => {
        const result = res?.data?.getReport;
        setActiveReport(result);
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
        setActiveReportLoading(false);
      });
  };

  useEffect(() => {
    if (data?.reportId && hasFeatureAccess) {
      getReport();
    }
  }, [JSON.stringify(data)]);

  useEffect(() => {
    if (data?.reportId && hasFeatureAccess) {
      setLoading(true);
      setActiveReportLoading(true);
    }
  }, [data?.reportId]);

  if (loading && hasFeatureAccess) {
    return (
      <div className="flex-center full-height">
        <Loading className="w90" />
      </div>
    );
  }

  if (!isInvoiceStatementsReport) {
    return null;
  }

  return (
    <div className="m10 h95 scroll">
      <InvoiceStatementsSheet data={data} />
    </div>
  );
}

export default InvoiceStatementsReport;
